import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0b4b1043"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"color":"red"} }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { style: {"display":"flex","align-items":"center","width":"100%"} }
const _hoisted_5 = { style: {"margin-top":"35px","max-height":"150px","overflow-y":"scroll"} }
const _hoisted_6 = { style: {"display":"flex","justify-content":"space-between"} }

import {
  withDefaults,
  ref,
  onMounted,
  computed
} from 'vue';
import {
  BaseDialog,
  BaseButton,
  BaseInputNumber,
  BaseForm,
  BaseFormItem,
  XrkMessage,
  BaseInput,
  BaseTextContent,
  BaseNotification
} from 'xrk-components';
import {
  getEnterpriseAccountBalance,
  getEnterpriseBankInfo,
  sendWithdrawMsg,
  submitCashOut
} from '../data-source/apis';
import {
  GetEnterpriseAccountBalanceData,
  GetEnterpriseBankInfoData,
  SubmitCashOutParams
} from '../data-source/types';
import { PayPassagewayCode } from '@cTypes/bank';
import { translator, formatter } from '@/utils';
import { useCountdown } from '@/hooks';
import { FunctionCode } from '@/common/types/user';


export default /*#__PURE__*/_defineComponent({
  __name: 'account-main-withdrawal-dialog',
  props: {
    remove: { type: Function, default() {
      return () => {
        console.log('remove');
      };
    } },
    payPassagewayCode: {},
    amount: {},
    idList: {},
    functionCode: { default: 2 }
  },
  emits: ['success'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit;
const props = __props;

const { text, start, disabled, stop } = useCountdown();

const withdrawalInfo = ref<
  GetEnterpriseAccountBalanceData & GetEnterpriseBankInfoData
>({
  balance: 0,
  amount: 0,
  waitAmount: 0,
  companyName: '',
  bankName: '',
  openName: '',
  openBankNumber: '',
  auditWidhdrawLog: [],
  withdrawFee: 0,
  phone: ''
});
const formRef = ref(null);
const formData = ref({
  amount: props.amount ? translator.fen2yuan(props.amount) : 0, // 用户输入金额，元
  remark: '', // 备注
  verifyCode: '' // 验证码
});
const rules = {
  verifyCode: [{ required: true, message: '请输入', trigger: 'blur' }],
  amount: [
    {
      required: true,
      trigger: 'blur',
      validator: (_, value, callback) => {
        if (!value) {
          return callback(new Error('请输入'));
        }
        // 反向判断，优先err。
        if (
          !(formAmountFen.value >= minAmount.value) ||
          formAmountFen.value > withdrawalInfo.value.amount
        ) {
          return callback(
            new Error(
              `请输入${translator.fen2yuan(
                minAmount.value
              )}~${translator.fen2yuan(withdrawalInfo.value.amount)}之间的金额`
            )
          );
        }
        // 输入金额 >= 最小可提现金额 &&  输入金额 <= 可提现金额
        callback();
      }
    }
  ]
};

const isAspWithdrawal = computed(() => {
  return props.functionCode === 2;
});
const showAmountInput = computed(() => {
  return withdrawalInfo.value.amount > 0;
});
const formAmountFen = computed(() => {
  return translator.yuan2fen(formData.value.amount);
});
// 最小可提现金额，至少1毛钱
const minAmount = computed(() => withdrawalInfo.value.withdrawFee + 100);
// 实际到账金额
const amountReceived = computed(() => {
  return formAmountFen.value - withdrawalInfo.value.withdrawFee;
});
const amountDisabled = computed(() => {
  return !!props.amount;
});

const onSendSms = async () => {
  if (disabled.value) return;
  try {
    start();
    await sendWithdrawMsg();
    XrkMessage.success({
      message: '发送成功，请注意查收'
    });
  } catch (e) {
    stop();
  }
};
const onConfirm = async () => {
  await formRef.value.validate();
  try {
    await submitCashOut({
      payPassagewayCode: props.payPassagewayCode,
      ...formData.value,
      amount: formAmountFen.value,
      ...(props.idList && { idList: props.idList })
    });
    BaseNotification.success('提交成功');
  } catch (e) {
    BaseNotification({
      title: '提现失败',
      message: e.data.message,
      type: 'error'
    });
  }
  emits('success');
  props.remove();
};

onMounted(async () => {
  const [balance, bank] = await Promise.all([
    getEnterpriseAccountBalance(),
    getEnterpriseBankInfo()
  ]);
  Object.assign(withdrawalInfo.value, balance.data, bank.data);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BaseDialog), {
    title: "提现到账银行卡",
    class: "form-dialog",
    width: "450px",
    "model-value": true,
    "show-close": true,
    "close-on-press-escape": false,
    "close-on-click-modal": false,
    showFooter: false
  }, {
    footer: _withCtx(() => [
      _createVNode(_unref(BaseButton), {
        type: "default",
        onClick: _ctx.remove
      }, {
        default: _withCtx(() => [
          _createTextVNode("取消")
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_unref(BaseButton), {
        type: "primary",
        click: onConfirm
      }, {
        default: _withCtx(() => [
          _createTextVNode("提现")
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(BaseTextContent), { style: {"max-height":"500px","overflow-y":"scroll"} }, {
        default: _withCtx(() => [
          _createVNode(_unref(BaseForm), {
            class: "enterprise-real-form-content",
            ref_key: "formRef",
            ref: formRef,
            "label-position": "top",
            model: formData.value,
            rules: rules
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(BaseFormItem), {
                label: "公司名称",
                prop: "companyName"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(BaseInput), {
                    class: "form-dialog__w280",
                    type: "text",
                    disabled: "",
                    modelValue: withdrawalInfo.value.companyName,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((withdrawalInfo.value.companyName) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_unref(BaseFormItem), {
                label: "开户行",
                prop: "bankName"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(BaseInput), {
                    class: "form-dialog__w280",
                    type: "text",
                    disabled: "",
                    modelValue: withdrawalInfo.value.bankName,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((withdrawalInfo.value.bankName) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_unref(BaseFormItem), {
                label: "开户名",
                prop: "openName"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(BaseInput), {
                    class: "form-dialog__w280",
                    type: "text",
                    disabled: "",
                    modelValue: withdrawalInfo.value.openName,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((withdrawalInfo.value.openName) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_unref(BaseFormItem), {
                label: "银行卡号",
                prop: "openBankNumber"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(BaseInput), {
                    class: "form-dialog__w280",
                    type: "text",
                    disabled: "",
                    modelValue: withdrawalInfo.value.openBankNumber,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((withdrawalInfo.value.openBankNumber) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_unref(BaseFormItem), {
                label: "提现金额",
                prop: "amount"
              }, {
                default: _withCtx(() => [
                  (showAmountInput.value)
                    ? (_openBlock(), _createBlock(_unref(BaseInputNumber), {
                        key: 0,
                        style: {"width":"100%"},
                        valueOnClear: "max",
                        clearable: "",
                        placeholder: `请输入可提现金额 ${_unref(formatter).fen2yuan(minAmount.value)}`,
                        disabled: amountDisabled.value,
                        controls: false,
                        precision: 2,
                        min: 0,
                        max: _unref(translator).fen2yuan(withdrawalInfo.value.amount),
                        modelValue: formData.value.amount,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.amount) = $event))
                      }, null, 8, ["placeholder", "disabled", "max", "modelValue"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_1, [
                (isAspWithdrawal.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, " 当前可提现金额：" + _toDisplayString(_unref(formatter).fen2yuan(withdrawalInfo.value.amount)) + "元 ", 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", null, " 手续费：" + _toDisplayString(_unref(formatter).fen2yuan(withdrawalInfo.value.withdrawFee)) + "元 ", 1),
                (formData.value.amount)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, " 实际到账金额：" + _toDisplayString(_unref(formatter).fen2yuan(amountReceived.value)) + "元 ", 1))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(_unref(BaseFormItem), { prop: "remark" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(BaseInput), {
                    type: "textarea",
                    style: {"width":"100%","margin-top":"20px"},
                    placeholder: "请输入备注，最大支持100字符",
                    clearable: "",
                    "show-word-limit": "",
                    rows: 3,
                    maxlength: 100,
                    modelValue: formData.value.remark,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.remark) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_unref(BaseFormItem), {
                prop: "verifyCode",
                label: `提现验证 ${withdrawalInfo.value.phone}`,
                "label-position": "top"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_unref(BaseInput), {
                      style: {"margin-right":"15px","flex":"1"},
                      type: "text",
                      placeholder: "请输入短信验证码",
                      clearable: "",
                      maxlength: 4,
                      inputTexts: ['数字'],
                      modelValue: formData.value.verifyCode,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.verifyCode) = $event))
                    }, null, 8, ["modelValue"]),
                    _createVNode(_unref(BaseButton), {
                      style: {"width":"100px"},
                      disabled: _unref(disabled),
                      click: onSendSms
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(text)), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ])
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _: 1
          }, 8, ["model"]),
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(withdrawalInfo.value.auditWidhdrawLog, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                style: {"margin-bottom":"10px"},
                key: index
              }, [
                _createElementVNode("p", null, _toDisplayString(item.authStatus === 1 ? '通过' : '驳回') + "：", 1),
                _createElementVNode("p", null, _toDisplayString(item.remark), 1),
                _createElementVNode("p", _hoisted_6, [
                  _createElementVNode("span", null, _toDisplayString(_unref(formatter).date(item.auditAt)), 1),
                  _createElementVNode("span", null, _toDisplayString(_unref(formatter).fen2yuan(item.price)), 1)
                ])
              ]))
            }), 128))
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})